<template>
  <div class="filing">
    <div class="container">
      <el-link type="primary" @click="open">免责声明 </el-link>
      <el-link :underline="false" type="primary" style="margin-left: 7px;" class="number">河北国超信息科技有限公司 冀ICP备05017071号</el-link>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    methods: {
      open() {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: '<div class="mianze">' +
            '<p>第 一 条</p><p>本网站所刊载的所有资料及图表仅供参考使用。参阅本网站上所刊的文档的人士，应被视为已确认得悉上述立场。投资者依据本网站提供的信息、资料及图表进行金融、证券等投资项目所造成的盈亏与本网站无关。</p>' +
            '<p>第 二 条</p><p>由于与本网站链接的其它网站所造成之个人资料泄露及由此而导致的任何法律争议和后果，本网站均得免责。</p>' +
            '<p>第 三 条</p><p>本网站如因系统维护或升级而需暂停服务时，将事先公告。若因线路及非本公司控制范围外的硬件故障或其它不可抗力而导致暂停服务，于暂停服务期间造成的一切不便与损失，本网站不负任何责任。</p>' +
            '<p>第 四 条</p><p>本网站使用者因为违反本声明的规定而触犯中华人民共和国法律的，一切后果自己负责，本网站不承担任何责任。</p>' +
            '<p>第 五 条</p><p>凡以任何方式登陆本网站或直接、间接使用本网站资料者，视为自愿接受本网站声明的约束。</p>' +
            '<p>第 六 条</p><p>本声明未涉及的问题参见国家有关法律法规，当本声明与国家法律法规冲突时，以国家法律法规为准。</p>' +
            '<p>第 七 条</p><p>本网站之声明以及其修改权、更新权及最终解释权均属河北国超信息科技有限公司所有。</p>' +
            '<div>',
          duration: 0,
          type: 'warning',
          showClose: true
        });
      }
    }
  }
</script>

<style>
  .mianze p {
    margin: 15px;
    color: rgba(0, 0, 0, 0.7) !important;
  }

  .el-message {
    box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 15px 3px;
  }

  .el-message__closeBtn {
    top: 20px !important;
  }

  @media (max-width:600px) {
    .mianze {
      max-height: 600px;
      overflow-y: scroll;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Filing.vue